import React from 'react';
import { CustomProvider } from 'rsuite';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';
import { StoreProvider } from 'easy-peasy';
import './i18n';
import {
  returnMomentLocale,
  returnRsuiteLocale
} from './utils/return-locales.utils';

returnMomentLocale();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <CustomProvider locale={returnRsuiteLocale()}>
        <App />
      </CustomProvider>
    </StoreProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
